import { render, staticRenderFns } from "./Personalarchives.vue?vue&type=template&id=de322d18&style=height%3A%20100%25%3B"
import script from "./Personalarchives.vue?vue&type=script&lang=js"
export * from "./Personalarchives.vue?vue&type=script&lang=js"
import style0 from "./Personalarchives.vue?vue&type=style&index=0&id=de322d18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports